import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Switch,
  TextField,
  Button,
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'state/api';
import { useSnack, SaveSnackbar } from './settingsHelper';

const CookieSettings = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation();
  const { snack, showSuccess, showError, closeSnack } = useSnack();

  const [cookieEnabled, setCookieEnabled] = useState(true);
  const [cookieText, setCookieText] = useState(
    "By clicking 'Yes, I agree', you agree to store cookies on your device and disclose information in accordance with our Cookie Policy."
  );

  useEffect(() => {
    const c = settings.custom?.cookieSettings;
    if (!c) return;
    if (c.cookieEnabled !== undefined) setCookieEnabled(c.cookieEnabled);
    if (c.cookieText !== undefined) setCookieText(c.cookieText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleCookieEnabledChange = (event) => {
    setCookieEnabled(event.target.checked);
  };

  const handleCookieTextChange = (event) => {
    setCookieText(event.target.value);
  };

  const handleSave = async () => {
    try {
      await updateSettings({
        custom: { cookieSettings: { cookieEnabled, cookieText } },
      }).unwrap();
      showSuccess();
    } catch (err) {
      showError(err?.data?.error?.message);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">
          <ShoppingCartIcon sx={{ mr: 1 }} /> Cookie Settings:
        </Typography>
        <Switch checked={cookieEnabled} onChange={handleCookieEnabledChange} />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Cookie Text"
          multiline
          rows={4}
          value={cookieText}
          onChange={handleCookieTextChange}
        />
      </Grid>

      <Grid item xs={12}>
        <Button variant="contained" color="primary" fullWidth onClick={handleSave} disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Save'}
        </Button>
      </Grid>

      <SaveSnackbar snack={snack} onClose={closeSnack} />
    </Grid>
  );
};

export default CookieSettings;
